// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconShieldPlus = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13 10h3v2h-3v3h-2v-3H8v-2h3V7h2z" />,
    <path
      fillRule="evenodd"
      d="M3 2h18v11.4c0 2.07-1.045 4.211-2.632 5.815C16.769 20.83 14.525 22 12 22s-4.77-1.17-6.368-2.785C4.045 17.611 3 15.47 3 13.4zm2 2v9.4c0 1.427.746 3.087 2.054 4.408C8.35 19.118 10.106 20 12 20s3.65-.881 4.946-2.192C18.254 16.487 19 14.828 19 13.4V4z"
    />
  );
export default SvgIconShieldPlus;
